import { NavLink as NavigationLink, NavLinkProps } from 'react-router-dom';

export const NavLink = ({ children, ...props }: NavLinkProps) => (
  <NavigationLink {...props}>{children}</NavigationLink>
);
